import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ConfirmationModalModule } from '../modals/confirmation-modal/confirmation-modal.module';
import { PendingClaimItemComponent } from './pending-claim-item.component';

@NgModule({
    imports: [
        CommonModule,
        ConfirmationModalModule,
    ],
    exports: [PendingClaimItemComponent],
    declarations: [PendingClaimItemComponent],
})
export class PendingClaimItemModule { }
